module.exports = __webpack_public_path__ + "img/2308-c1.04582712.png";